import React from 'react';
import { FormCheckbox } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const WebformCheckbox = (props) => {
  const { entity, customClasses, type, errors, ...fieldProps } = props;
  const title = entity.get('#title');
  const required = entity.get('#required');
  const description = entity.get('#description');
  const descriptionAboveInput = entity.get('#description_above_input');
  const requiredError = entity.get('#required_error');
  const key = entity.get('#webform_key');
  const validation = (value) => {
    let error;
    if (required && !value) {
      error = requiredError || 'Dit is een verplicht veld.';
    }
    return error;
  };

  return (
    <FormCheckbox
      {...fieldProps}
      fieldName={key}
      title={title}
      required={required}
      error={errors?.[key]}
      validation={validation}
      description={description}
      descriptionAboveInput={!!descriptionAboveInput}
      wrapperClassName="WebformCheckboxWrapper"
    />
  );
};

export default WebformCheckbox;
